import { TemplateResult, html, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './tufts-icon-navigator.css.lit';
import { tuftsCard } from '../tufts-card/tufts-card';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';

/**
 * The Tufts Card Icon Callout component
 * @element tufts-icon-with-paragraph
 *
 * @slot heading
 * @slot description
 * @slot cta
 */

@customElement('tufts-icon-navigator')
export class tuftsIconNavigator extends tuftsCard {
  static styles: CSSResultGroup = [componentStyles, tuftsHeadingCssLit];

  desktopRender(): TemplateResult {
    return html`
      <article class="desktop-wrapper">
        <div class="content-wrapper">
          ${this.ngSlot.conditionalNGSlot('heading', true, 'xl')}
          ${this.ngSlot.conditionalNGSlot('description')}
          ${this.ctaTemplate1('cta', this.setColorTemplate())}
        </div>
        <div class="icon-button-group">
          ${this.ngSlot.conditionalNGSlot('icon-group')}
        </div>
      </article>
    `;
  }

  mobileRender(): TemplateResult {
    return html`
      <article class="mobile-wrapper">
        ${this.ngSlot.conditionalNGSlot('heading', true, 'xl')}
        ${this.ngSlot.conditionalNGSlot('description')}
        ${this.ngSlot.conditionalNGSlot('icon-group')}
        ${this.ctaTemplate1('cta', this.setColorTemplate())}
      </article>
    `;
  }
  render(): TemplateResult {
    return html`
      ${this.resizeController.currentBreakpointRange === 0
        ? this.mobileRender()
        : this.desktopRender()}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-icon-navigator': tuftsIconNavigator;
  }
}
